/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as StartImport } from './routes/start'
import { Route as LoginImport } from './routes/login'
import { Route as CreateFeedDefinitionImport } from './routes/create-feed-definition'
import { Route as PasswordresetLayoutImport } from './routes/_passwordreset-layout'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as StartIndexImport } from './routes/start.index'
import { Route as SSurveyIdImport } from './routes/s/$surveyId'
import { Route as AuthenticatedWelcomeImport } from './routes/_authenticated/welcome'
import { Route as AuthenticatedAppImport } from './routes/_authenticated/app'
import { Route as PasswordresetLayoutPasswordresetIndexImport } from './routes/_passwordreset-layout/passwordreset/index'
import { Route as PasswordresetLayoutResetDoneImport } from './routes/_passwordreset-layout/reset/done'
import { Route as PasswordresetLayoutPasswordresetDoneImport } from './routes/_passwordreset-layout/passwordreset/done'
import { Route as PasswordresetLayoutResetUidb64SetPasswordImport } from './routes/_passwordreset-layout/reset/$uidb64.set-password'
import { Route as PasswordresetLayoutResetUidb64TokenImport } from './routes/_passwordreset-layout/reset/$uidb64.$token'
import { Route as AuthenticatedAppPlayersPlayerIdImport } from './routes/_authenticated/app/players/$playerId'
import { Route as AuthenticatedAppAccountsAccountIdImport } from './routes/_authenticated/app/accounts/$accountId'
import { Route as AuthenticatedAppPlayersPlayerIdIndexImport } from './routes/_authenticated/app/players/$playerId/index'
import { Route as AuthenticatedAppAccountsAccountIdIndexImport } from './routes/_authenticated/app/accounts/$accountId/index'
import { Route as AuthenticatedAppPlayersPlayerIdInsightsImport } from './routes/_authenticated/app/players/$playerId/insights'
import { Route as AuthenticatedAppAccountsAccountIdPlayersImport } from './routes/_authenticated/app/accounts/$accountId/players'

// Create Virtual Routes

const IndexLazyImport = createFileRoute('/')()

// Create/Update Routes

const StartRoute = StartImport.update({
  path: '/start',
  getParentRoute: () => rootRoute,
} as any)

const LoginRoute = LoginImport.update({
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const CreateFeedDefinitionRoute = CreateFeedDefinitionImport.update({
  path: '/create-feed-definition',
  getParentRoute: () => rootRoute,
} as any)

const PasswordresetLayoutRoute = PasswordresetLayoutImport.update({
  id: '/_passwordreset-layout',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const IndexLazyRoute = IndexLazyImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))

const StartIndexRoute = StartIndexImport.update({
  path: '/',
  getParentRoute: () => StartRoute,
} as any)

const SSurveyIdRoute = SSurveyIdImport.update({
  path: '/s/$surveyId',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedWelcomeRoute = AuthenticatedWelcomeImport.update({
  path: '/welcome',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedAppRoute = AuthenticatedAppImport.update({
  path: '/app',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const PasswordresetLayoutPasswordresetIndexRoute =
  PasswordresetLayoutPasswordresetIndexImport.update({
    path: '/passwordreset/',
    getParentRoute: () => PasswordresetLayoutRoute,
  } as any)

const PasswordresetLayoutResetDoneRoute =
  PasswordresetLayoutResetDoneImport.update({
    path: '/reset/done',
    getParentRoute: () => PasswordresetLayoutRoute,
  } as any)

const PasswordresetLayoutPasswordresetDoneRoute =
  PasswordresetLayoutPasswordresetDoneImport.update({
    path: '/passwordreset/done',
    getParentRoute: () => PasswordresetLayoutRoute,
  } as any)

const PasswordresetLayoutResetUidb64SetPasswordRoute =
  PasswordresetLayoutResetUidb64SetPasswordImport.update({
    path: '/reset/$uidb64/set-password',
    getParentRoute: () => PasswordresetLayoutRoute,
  } as any)

const PasswordresetLayoutResetUidb64TokenRoute =
  PasswordresetLayoutResetUidb64TokenImport.update({
    path: '/reset/$uidb64/$token',
    getParentRoute: () => PasswordresetLayoutRoute,
  } as any)

const AuthenticatedAppPlayersPlayerIdRoute =
  AuthenticatedAppPlayersPlayerIdImport.update({
    path: '/players/$playerId',
    getParentRoute: () => AuthenticatedAppRoute,
  } as any)

const AuthenticatedAppAccountsAccountIdRoute =
  AuthenticatedAppAccountsAccountIdImport.update({
    path: '/accounts/$accountId',
    getParentRoute: () => AuthenticatedAppRoute,
  } as any)

const AuthenticatedAppPlayersPlayerIdIndexRoute =
  AuthenticatedAppPlayersPlayerIdIndexImport.update({
    path: '/',
    getParentRoute: () => AuthenticatedAppPlayersPlayerIdRoute,
  } as any)

const AuthenticatedAppAccountsAccountIdIndexRoute =
  AuthenticatedAppAccountsAccountIdIndexImport.update({
    path: '/',
    getParentRoute: () => AuthenticatedAppAccountsAccountIdRoute,
  } as any)

const AuthenticatedAppPlayersPlayerIdInsightsRoute =
  AuthenticatedAppPlayersPlayerIdInsightsImport.update({
    path: '/insights',
    getParentRoute: () => AuthenticatedAppPlayersPlayerIdRoute,
  } as any)

const AuthenticatedAppAccountsAccountIdPlayersRoute =
  AuthenticatedAppAccountsAccountIdPlayersImport.update({
    path: '/players',
    getParentRoute: () => AuthenticatedAppAccountsAccountIdRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/_passwordreset-layout': {
      id: '/_passwordreset-layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PasswordresetLayoutImport
      parentRoute: typeof rootRoute
    }
    '/create-feed-definition': {
      id: '/create-feed-definition'
      path: '/create-feed-definition'
      fullPath: '/create-feed-definition'
      preLoaderRoute: typeof CreateFeedDefinitionImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/start': {
      id: '/start'
      path: '/start'
      fullPath: '/start'
      preLoaderRoute: typeof StartImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/app': {
      id: '/_authenticated/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AuthenticatedAppImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/welcome': {
      id: '/_authenticated/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof AuthenticatedWelcomeImport
      parentRoute: typeof AuthenticatedImport
    }
    '/s/$surveyId': {
      id: '/s/$surveyId'
      path: '/s/$surveyId'
      fullPath: '/s/$surveyId'
      preLoaderRoute: typeof SSurveyIdImport
      parentRoute: typeof rootRoute
    }
    '/start/': {
      id: '/start/'
      path: '/'
      fullPath: '/start/'
      preLoaderRoute: typeof StartIndexImport
      parentRoute: typeof StartImport
    }
    '/_passwordreset-layout/passwordreset/done': {
      id: '/_passwordreset-layout/passwordreset/done'
      path: '/passwordreset/done'
      fullPath: '/passwordreset/done'
      preLoaderRoute: typeof PasswordresetLayoutPasswordresetDoneImport
      parentRoute: typeof PasswordresetLayoutImport
    }
    '/_passwordreset-layout/reset/done': {
      id: '/_passwordreset-layout/reset/done'
      path: '/reset/done'
      fullPath: '/reset/done'
      preLoaderRoute: typeof PasswordresetLayoutResetDoneImport
      parentRoute: typeof PasswordresetLayoutImport
    }
    '/_passwordreset-layout/passwordreset/': {
      id: '/_passwordreset-layout/passwordreset/'
      path: '/passwordreset'
      fullPath: '/passwordreset'
      preLoaderRoute: typeof PasswordresetLayoutPasswordresetIndexImport
      parentRoute: typeof PasswordresetLayoutImport
    }
    '/_authenticated/app/accounts/$accountId': {
      id: '/_authenticated/app/accounts/$accountId'
      path: '/accounts/$accountId'
      fullPath: '/app/accounts/$accountId'
      preLoaderRoute: typeof AuthenticatedAppAccountsAccountIdImport
      parentRoute: typeof AuthenticatedAppImport
    }
    '/_authenticated/app/players/$playerId': {
      id: '/_authenticated/app/players/$playerId'
      path: '/players/$playerId'
      fullPath: '/app/players/$playerId'
      preLoaderRoute: typeof AuthenticatedAppPlayersPlayerIdImport
      parentRoute: typeof AuthenticatedAppImport
    }
    '/_passwordreset-layout/reset/$uidb64/$token': {
      id: '/_passwordreset-layout/reset/$uidb64/$token'
      path: '/reset/$uidb64/$token'
      fullPath: '/reset/$uidb64/$token'
      preLoaderRoute: typeof PasswordresetLayoutResetUidb64TokenImport
      parentRoute: typeof PasswordresetLayoutImport
    }
    '/_passwordreset-layout/reset/$uidb64/set-password': {
      id: '/_passwordreset-layout/reset/$uidb64/set-password'
      path: '/reset/$uidb64/set-password'
      fullPath: '/reset/$uidb64/set-password'
      preLoaderRoute: typeof PasswordresetLayoutResetUidb64SetPasswordImport
      parentRoute: typeof PasswordresetLayoutImport
    }
    '/_authenticated/app/accounts/$accountId/players': {
      id: '/_authenticated/app/accounts/$accountId/players'
      path: '/players'
      fullPath: '/app/accounts/$accountId/players'
      preLoaderRoute: typeof AuthenticatedAppAccountsAccountIdPlayersImport
      parentRoute: typeof AuthenticatedAppAccountsAccountIdImport
    }
    '/_authenticated/app/players/$playerId/insights': {
      id: '/_authenticated/app/players/$playerId/insights'
      path: '/insights'
      fullPath: '/app/players/$playerId/insights'
      preLoaderRoute: typeof AuthenticatedAppPlayersPlayerIdInsightsImport
      parentRoute: typeof AuthenticatedAppPlayersPlayerIdImport
    }
    '/_authenticated/app/accounts/$accountId/': {
      id: '/_authenticated/app/accounts/$accountId/'
      path: '/'
      fullPath: '/app/accounts/$accountId/'
      preLoaderRoute: typeof AuthenticatedAppAccountsAccountIdIndexImport
      parentRoute: typeof AuthenticatedAppAccountsAccountIdImport
    }
    '/_authenticated/app/players/$playerId/': {
      id: '/_authenticated/app/players/$playerId/'
      path: '/'
      fullPath: '/app/players/$playerId/'
      preLoaderRoute: typeof AuthenticatedAppPlayersPlayerIdIndexImport
      parentRoute: typeof AuthenticatedAppPlayersPlayerIdImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexLazyRoute,
  AuthenticatedRoute: AuthenticatedRoute.addChildren({
    AuthenticatedAppRoute: AuthenticatedAppRoute.addChildren({
      AuthenticatedAppAccountsAccountIdRoute:
        AuthenticatedAppAccountsAccountIdRoute.addChildren({
          AuthenticatedAppAccountsAccountIdPlayersRoute,
          AuthenticatedAppAccountsAccountIdIndexRoute,
        }),
      AuthenticatedAppPlayersPlayerIdRoute:
        AuthenticatedAppPlayersPlayerIdRoute.addChildren({
          AuthenticatedAppPlayersPlayerIdInsightsRoute,
          AuthenticatedAppPlayersPlayerIdIndexRoute,
        }),
    }),
    AuthenticatedWelcomeRoute,
  }),
  PasswordresetLayoutRoute: PasswordresetLayoutRoute.addChildren({
    PasswordresetLayoutPasswordresetDoneRoute,
    PasswordresetLayoutResetDoneRoute,
    PasswordresetLayoutPasswordresetIndexRoute,
    PasswordresetLayoutResetUidb64TokenRoute,
    PasswordresetLayoutResetUidb64SetPasswordRoute,
  }),
  CreateFeedDefinitionRoute,
  LoginRoute,
  StartRoute: StartRoute.addChildren({ StartIndexRoute }),
  SSurveyIdRoute,
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_authenticated",
        "/_passwordreset-layout",
        "/create-feed-definition",
        "/login",
        "/start",
        "/s/$surveyId"
      ]
    },
    "/": {
      "filePath": "index.lazy.tsx"
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/app",
        "/_authenticated/welcome"
      ]
    },
    "/_passwordreset-layout": {
      "filePath": "_passwordreset-layout.tsx",
      "children": [
        "/_passwordreset-layout/passwordreset/done",
        "/_passwordreset-layout/reset/done",
        "/_passwordreset-layout/passwordreset/",
        "/_passwordreset-layout/reset/$uidb64/$token",
        "/_passwordreset-layout/reset/$uidb64/set-password"
      ]
    },
    "/create-feed-definition": {
      "filePath": "create-feed-definition.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/start": {
      "filePath": "start.tsx",
      "children": [
        "/start/"
      ]
    },
    "/_authenticated/app": {
      "filePath": "_authenticated/app.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/app/accounts/$accountId",
        "/_authenticated/app/players/$playerId"
      ]
    },
    "/_authenticated/welcome": {
      "filePath": "_authenticated/welcome.tsx",
      "parent": "/_authenticated"
    },
    "/s/$surveyId": {
      "filePath": "s/$surveyId.tsx"
    },
    "/start/": {
      "filePath": "start.index.tsx",
      "parent": "/start"
    },
    "/_passwordreset-layout/passwordreset/done": {
      "filePath": "_passwordreset-layout/passwordreset/done.tsx",
      "parent": "/_passwordreset-layout"
    },
    "/_passwordreset-layout/reset/done": {
      "filePath": "_passwordreset-layout/reset/done.tsx",
      "parent": "/_passwordreset-layout"
    },
    "/_passwordreset-layout/passwordreset/": {
      "filePath": "_passwordreset-layout/passwordreset/index.tsx",
      "parent": "/_passwordreset-layout"
    },
    "/_authenticated/app/accounts/$accountId": {
      "filePath": "_authenticated/app/accounts/$accountId.tsx",
      "parent": "/_authenticated/app",
      "children": [
        "/_authenticated/app/accounts/$accountId/players",
        "/_authenticated/app/accounts/$accountId/"
      ]
    },
    "/_authenticated/app/players/$playerId": {
      "filePath": "_authenticated/app/players/$playerId.tsx",
      "parent": "/_authenticated/app",
      "children": [
        "/_authenticated/app/players/$playerId/insights",
        "/_authenticated/app/players/$playerId/"
      ]
    },
    "/_passwordreset-layout/reset/$uidb64/$token": {
      "filePath": "_passwordreset-layout/reset/$uidb64.$token.tsx",
      "parent": "/_passwordreset-layout"
    },
    "/_passwordreset-layout/reset/$uidb64/set-password": {
      "filePath": "_passwordreset-layout/reset/$uidb64.set-password.tsx",
      "parent": "/_passwordreset-layout"
    },
    "/_authenticated/app/accounts/$accountId/players": {
      "filePath": "_authenticated/app/accounts/$accountId/players.tsx",
      "parent": "/_authenticated/app/accounts/$accountId"
    },
    "/_authenticated/app/players/$playerId/insights": {
      "filePath": "_authenticated/app/players/$playerId/insights.tsx",
      "parent": "/_authenticated/app/players/$playerId"
    },
    "/_authenticated/app/accounts/$accountId/": {
      "filePath": "_authenticated/app/accounts/$accountId/index.tsx",
      "parent": "/_authenticated/app/accounts/$accountId"
    },
    "/_authenticated/app/players/$playerId/": {
      "filePath": "_authenticated/app/players/$playerId/index.tsx",
      "parent": "/_authenticated/app/players/$playerId"
    }
  }
}
ROUTE_MANIFEST_END */
